import { ReviewsPageContextBindings, ReviewsPageContextType } from '@/context/reviews-page.contract';

export const buildReviewsPageProviderValue = (bindings: ReviewsPageContextBindings): ReviewsPageContextType => bindings;
